import React from "react";
import { Outlet, NavLink } from "react-router-dom";
import "./AdminLayout.css";
import { useNavigate } from "react-router-dom";

const AdminLayout = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user"); // if you store user info
    navigate("/admin");
  };
  return (
    <div className="admin-layout">

      {/* Sidebar */}
      <aside className="admin-sidebar">
        <h2 className="admin-logo">Admin</h2>

        <nav className="admin-nav">
          <NavLink
            to="/admin/dashboard/candidates"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Candidates
          </NavLink>

          <NavLink
            to="/admin/dashboard/employees"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Employees
          </NavLink>

          <NavLink
            to="/admin/dashboard/monitoring"
            className={({ isActive }) =>
              isActive ? "nav-link active" : "nav-link"
            }
          >
            Monitoring
          </NavLink>
        </nav>
        {/* 👇 ADD THIS */}
        <div className="admin-nav admin-nav-bottom">
          <button onClick={handleLogout} className="nav-link nav-logout">
            Logout
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="admin-content">
        <Outlet />
      </main>

    </div>
  );
};

export default AdminLayout;
